module.exports = (__webpack_require__(24))(371);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/timers-browserify/main.js from dll-reference lib_core
// module id = 361
// module chunks = 110